import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungHeilbronn() {
  return (
    <CityPageTemplate
      city="Heilbronn"
      slug="heilbronn"
      intro="Heilbronn als aufstrebende Wirtschaftsregion am Neckar – jetzt ist der richtige Zeitpunkt für smarten Vermögensaufbau."
      description="Unabhängige & digitale Finanzberatung für Heilbronn: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
